module.exports = __webpack_public_path__ + "static/img/logo.f167002.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mheader/logo.png
// module id = M9ki
// module chunks = 1